import React, { useState } from 'react';

import ReactPaginate from 'react-paginate';
import { Box } from '@material-ui/core';
import Styles from './Pagination.scss';
import Select from 'react-select';

const paginationStyles = {
    input: (provided) => ({
        ...provided,
        padding: 0
    }),
    menu: (provided) => ({
        ...provided,
        color: '#404040',
        'font-weight': 400,
    }),
    singleValue: (provided, state) => {
        const color = '#28282E';
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return {
            ...provided, color, opacity, transition, padding: 0,
            'line-height': '20px',
            'font-weight': 400
        };
    },
    placeholder: (provided, state) => {
        const color = state.isDisabled ? '#0056ad' : '#28282E';
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return {
            ...provided,
            color, opacity, transition,
            'font-weight': 'normal'
        };
    },
    control: (provided) => ({
        ...provided,
        'line-height': '20px',
        padding: '3px 2px',
        color: '#28282E',
        'min-height': '40px'
    }),
    option: (provided) => ({
        ...provided,
        'font-family': 'Hind',
        'font-size': '16px',
        'font-stretch': 'normal',
        'font-style': 'normal',
        'letter-spacing': 'normal',
        'line-height': '20px',
        'font-weight': 400,
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#0056ad',
        '&:hover': {
            color: '#0056ad',
        },
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    })
};

const Pagination = ({ pagination, count, icons, rowsPerPageOptions, setPagination, onChangePagination, dataCy, footerLabel }) => {
    const [dataPerPage, setDataPerPage] = useState();
    const pageOptions = rowsPerPageOptions.map(s => ({ label: s, value: s }));

    const handlePageClick = (e) => {
        setPagination({ ...pagination, offset: e.selected * pagination.limit });
        onChangePagination({ ...pagination, offset: e.selected * pagination.limit });
    };

    const maxPageIndex = Math.max(0, Math.ceil(pagination.totalCount / pagination.limit) - 1);

    return (
        <Box className={Styles.Pagination__paginationContainer}>
            <div className={Styles.Pagination__pageViewSection}>
                <Box componment="span">
                    View
                </Box>
                <div className={Styles.Pagination__pageSelect}>
                    <Select
                        options={pageOptions}
                        styles={paginationStyles}
                        defaultValue={pageOptions.find(s => s.value === pagination.limit)}
                        placeholder=""
                        menuPlacement='auto'
                        value={dataPerPage}
                        isSearchable={false}
                        onChange={(e) => {
                            setDataPerPage(e);
                            setPagination({ ...pagination, limit: e.value, offset: 0 });
                            onChangePagination({ ...pagination, limit: e.value, offset: 0 });
                        }}
                    />
                </div>
                <Box component="span">{footerLabel ? `${footerLabel} per page` : 'users per page'}</Box>
            </div>
            <Box className={Styles.Pagination__pageViewSection}>
                <Box component={'span'} pr="50px">
                    {`Showing ${pagination.offset > 0 && pagination.totalCount > 10 ? pagination.offset + 1 : 1}-${Math.min(pagination.totalCount, pagination.offset + pagination.limit)} of ${pagination.totalCount}`}
                </Box>
                <ReactPaginate
                    breakLabel="..."
                    breakClassName={Styles.Pagination__breakLabel}
                    nextLabel={<icons.NextPage /> || '>'}
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    pageCount={Math.max(1, Math.ceil(pagination.totalCount / pagination.limit))}
                    previousLabel={<icons.PreviousPage /> || '<'}
                    renderOnZeroPageCount={null}
                    activeClassName={Styles.Pagination__selected}
                    containerClassName={Styles.Pagination__paginationPage}
                    nextClassName={Styles.Pagination__previousLabel}
                    previousClassName={Styles.Pagination__previousLabel}
                    disabledClassName={Styles.Pagination__previousLabel__disabled}
                    pageClassName={Styles.Pagination__page}
                    menuPosition="absolute"
                    marginPagesDisplayed={1}
                    forcePage={Math.min(pagination.totalCount < 10 ? 0 : Math.floor(pagination.offset / pagination.limit), maxPageIndex)}
                    data-cy={dataCy}
                    pageLinkClassName={Styles.Pagination__page}
                />
            </Box>
        </Box>
    );
};
export default Pagination;